import { Button, Flex, Text } from "@gravity-ui/uikit";
import { Link } from "react-router-dom";
import { PageMeta, ScrollToAnchor } from "src/components";
import { appConfig } from "src/config";
import { T, useTranslate } from "src/i18n";
import { RoutesPaths } from "src/routes/RoutesPaths";
import { Footer, Header } from "src/widgets";

import { DotHighlightBackground } from "../LandingPage/components";
import {
  MainBlock,
  PlatformComparisonBlock,
  PlatformsBlock,
  ServicesBlock,
  WhyUsBlock,
} from "./components";
import { useOutsourcingPageLinks } from "./hooks/useOutsourcingPageLinks";

export const OutsourcingServicesPage = () => {
  const outsourcingPageLinks = useOutsourcingPageLinks();
  const { t } = useTranslate();

  const title = t(
    "outsourcing.meta.title",
    "Магазин под ключ — {displayName}",
    { displayName: appConfig.displayName },
  );
  const description = t(
    "outsourcing.meta.description",
    "Запустим интернет-магазин товаров с Poizon/1688 под ключ: от настройки каталога до интеграции с маркетплейсами.",
  );

  return (
    <Flex
      direction={"column"}
      justifyContent={"center"}
      alignItems={"center"}
      style={{ gap: 140 }}
    >
      <PageMeta title={title} description={description} path="/outsourcing" />
      <ScrollToAnchor />
      <DotHighlightBackground>
        <Header
          links={outsourcingPageLinks}
          actions={
            <>
              <Link to={RoutesPaths.LK.BASE_PATH}>
                <Button size="l" view="action" href={RoutesPaths.LK.BASE_PATH}>
                  <Text variant="subheader-1">
                    <T
                      keyName="header.login_button"
                      defaultValue="Начать пользоваться"
                    />
                  </Text>
                </Button>
              </Link>
            </>
          }
        />
        <MainBlock />
      </DotHighlightBackground>

      <PlatformsBlock />
      <PlatformComparisonBlock />
      <WhyUsBlock />
      <ServicesBlock />
      <Footer />
    </Flex>
  );
};
